import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useAiAppraisalToggle } from '@/helpers/aiAppraisalToggle'
import IconRealEstate from '@/icons/24/house.svg'
import { cn } from '@/utils/cn'
import IconAiWertCheck from './assets/icon_ai_wert_check.svg'
import IconCarPawn from './assets/icon_car_pawn.svg'
import IconPawn from './assets/icon_pawn.svg'

export function MobileSubHeader() {
  const { t } = useTranslation()
  const aiWertCheckEnabled = useAiAppraisalToggle()

  return (
    <div className="md:hidden bg-white flex flex-row justify-around items-center font-semibold px-2 overflow-x-auto">
      <SegmentLink path="/pfandkredit">
        <IconPawn className="m-px mr-0" />
        {t('common:header.pawn_loan')}
      </SegmentLink>
      {aiWertCheckEnabled && (
        <SegmentLink path="/wert-check">
          <IconAiWertCheck className="m-px mr-0" />
          {t('common:header.ai_wert_check')}
        </SegmentLink>
      )}
      <SegmentLink path="/autopfand">
        <IconCarPawn />
        {t('common:header.car_pawn')}
      </SegmentLink>
      <SegmentLink path="/immobilien">
        <IconRealEstate className="m-0.5 mr-0" />
        {t('common:header.real_estate')}
      </SegmentLink>
    </div>
  )
}

function SegmentLink({
  path,
  children,
}: {
  path: string
  children: React.ReactNode
}) {
  const isPathActive = usePathname() === path

  return (
    <Link className="flex-1 flex justify-center" href={path}>
      <span
        className={cn(
          'pl-0.5 pr-1 gap-1 rounded-md border text-xs inline-flex items-center whitespace-nowrap',
          isPathActive ? 'border-black' : 'border-transparent',
        )}
      >
        {children}
      </span>
    </Link>
  )
}

export const MOBILE_SUB_HEADER_PATHS = [
  '/',
  '/pfandkredit',
  '/wert-check',
  '/autopfand',
  '/verkaufen-mit-cashy',
]
